<template>
  <v-autocomplete
    :loading="loading"
    :search-input.sync="entitiesSearchQuery"
    :items="getEntities"
    v-bind="$attrs"
    outlined
    dense
    :filter="customFilter"
    @input="handleInputChange"
    :value="value"
    :label="label"
    :rules="required ? [(v) => !!v || 'Entité requise'] : []"
  >
    <template v-slot:item="{ item }">
      {{ item.id + ' - ' + item.short_name }}
    </template>
    <template v-slot:selection="data">
      <v-chip
        v-bind="data.attrs"
        :value="data.selected"
        close
        small
        @click:close="handleInputChange(null)"
      >
        {{ data.item.id }}
      </v-chip>
    </template>
  </v-autocomplete>
</template>
<script>
import { mapGetters } from 'vuex';
import createReusableBaseModule from '@/store/reusableBaseModule';
import { generateMessage } from '@/utils/i18n';
import EntitiesService from '@/services/services/entities.service';

export default {
  name: 'custom-entity-selector',
  computed: {
    ...mapGetters({
      topLevelEntities: 'entities/toplevel/items',
    }),
    searchEntitiesItems: {
      get() {
        return this.$store.getters[`${this.module.path}/items`];
      },
    },
    loading: {
      get() {
        return this.$store.getters[`${this.module.path}/isLoadingItems`];
      },
    },
    label() {
      return (
        this.generateMessage('actionplans.create.entity') +
        (this.required ? ' *' : '')
      );
    },
    getEntities() {
      return (
        (this.searchEntitiesItems &&
          this.searchEntitiesItems.length > 0 &&
          this.searchEntitiesItems) ||
        this.topLevelEntities
      );
    },
  },
  created() {
    const { names, path } = createReusableBaseModule({
      store: this.$store,
      // eslint-disable-next-line no-underscore-dangle
      name: `${this.$options.name}/${this._uid}`,
      searchAttributesArray: ['id', 'name', 'short_name', 'nav_full_id'],
      serviceAPI: EntitiesService,
    });
    this.module.names = names;
    this.module.path = path;
    this.$store.dispatch(`${this.module.path}/search`, this.value);
  },
  props: {
    value: {
      type: String,
      required: false,
    },
    required: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      module: {},
      entitiesSearchQuery: null,
    };
  },
  methods: {
    generateMessage,
    customFilter(item, queryText) {
      const textOne = item.short_name.toLowerCase();
      const textTwo = item.id.toLowerCase();
      const textThree = item.nav_full_id.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 ||
        textTwo.indexOf(searchText) > -1 ||
        textTwo.indexOf(textThree) > -1
      );
    },
    handleInputChange(val) {
      this.$emit('input', val);
    },
  },
  watch: {
    entitiesSearchQuery(val) {
      if (val && val !== this.value)
        this.$store.dispatch(`${this.module.path}/search`, val);
    },
    value: {
      handler(newVal) {
        this.$store.dispatch(`${this.module.path}/search`, newVal);
      },
    },
  },
  beforeDestroy() {
    // Unregister the dynamically created module
    this.$store.unregisterModule(this.module.names);
  },
};
</script>
